<template lang="pug">
  #material
    header.materialPost__header
      button.materialPost__back(@click="$router.push('/')")
        fa(icon="home")
        span &nbsp; Home
      router-link.title.is-4(to="/itc/instructionalplans" style="margin: 0; padding: 0; font-weight: lighter; font-size: 1.5rem; text-transform: uppercase")
        i(style="color: #049FD9") Training Materials
      span(style="display: inline-block; width: 8rem")
    div.material__description(style="margin-left: auto; margin-right:auto;")
      span This page is a list of self-learning materials on different topics from ITC-organized trainings. We want to make sure that you will be provided with the needed resources while honing your IT skills and add recourse to your existing instructional materials. Video clips were shared in Google Drive so make sure you have your Google account to easily access the materials. Happy viewing!
    
    div.materials
      layout-container(style="max-width:900px")
        .material(v-for="material, index in $store.state.material.material" :to="'/itc/trainingmaterials/' + material.id" :key="material.id")
          div.material__banner(:style="{backgroundImage: 'url(' + material.cover + ')'}")
          div.material__contents
            h2.title.is-3.material__title {{ material.topic }}
            p.classroom__body.unsetNodes(v-html="material.description")
            button.material__button.--primary
              h3.material__content #[a(:href="material.link" target="_blank") Video ]

</template>

<style lang="sass" scoped>
@import '../assets/style'

.title    
  color: #00b8e6
  text-shadow: 1px 1px #b3b3cc

.materialPost__header
  max-width: 900px
  margin-left: auto
  padding: $pad 0
  margin-right: auto
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  border-bottom: 1px solid #dddddd

.materialPost__back
  background-color: transparent

.materialsHeader
  background-color: $color-primary
  color: $color-against-primary

.materialsNav
  display: flex
  align-items: center
  justify-content: space-between
  height: 4rem

.material__title
  font-weight: lighter
  margin-bottom: 1.5rem
  color: #00b8e6
  text-shadow: 1px 1px #b3b3cc
  

.materialsNav__action
  padding: 1rem
  @include actionable-primary
  display: flex
  align-items: center
  justify-content: center
  border-radius: 3rem
  height: 3rem
  margin: 0.5rem
  text-decoration: none
  color: inherit

.materialsNav__action--small
  width: 3rem

.material
  border-radius: 0.5rem
  background-color: $color-background-light
  margin: $pad 0
  border: 1px solid $color-layout-border
  overflow: hidden
  display: grid
  grid-template-columns: 1fr
  text-decoration: none
  color: inherit

  @include from($tablet-portrait)
    grid-template-columns: 1fr 1fr


.material__banner
  width: 100%
  background-color: #ddd
  background-size: cover
  background-position: center

  height: 60vw
  @include from($tablet-portrait)
    height: 28rem

.material__contents
  padding: $pad
  border-right: 10px solid #00b8e6
  box-shadow: 5px 20px #b3b3cc

.material__button
  margin: 1vw 1vw 1vw 0

h3 a:link
  color: #fff

h3 a:visited
  color: #fff

h3 a:hover
  color: white

.material__description
  max-width: 900px 
  color: $color-primary
  padding: 15px
  border-radius: 7px
  font-weight: normal
  margin-bottom: 3em
  text-shadow: 0px 1px gray

</style>



<script>
import layoutContainer from '@/components/layoutContainer'
import homeNav from '@/components/homeNav'
export default {
  name: 'materials',
  components: {
    layoutContainer,
    homeNav
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch('loadMaterial');
  }
}
</script>